export enum AlertCategory {
    PATIENT = 'PATIENT',
    STAFF = 'STAFF',
}

export enum AlertStatus {
    OPEN = 'OPEN',
    RESOLVED = 'RESOLVED',
}

export interface IAlert {
    alertId: string;
    createdAt: string;
    createdBy: string;
    resolvedAt?: string;
    resolvedBy?: string;
    resolutionNotes?: string;
    status: AlertStatus;
    category?: AlertCategory;
    acknowledged: boolean;
    acknowledgedAt?: string | null;
    acknowledgedBy?: string | null;
}

interface Alert extends IAlert {}

class Alert {
    constructor(data: IAlert) {
        Object.assign(this, data);
    }
}

export { Alert };
